import { createReducer, INITIAL_STATE } from '../../../../shared/redux';
import { Subscription, RecurrencePaymentMethod } from '../../subscription/subscription.types';
import { DEFAULT_CURRENCY_USD } from './simulation-form/simulation-form.constants';

export const GET_INITIAL_ORDER_SIMULATION = '@billing/order/simulation/GET_INITIAL_ORDER_SIMULATION';
export const SET_INITIAL_ORDER_SIMULATION = '@billing/order/simulation/SET_INITIAL_ORDER_SIMULATION';
export const EDIT_ORDER_SIMULATION = '@billing/order/simulation/EDIT_ORDER_SIMULATION';

export interface BillingOrderSimulationState {
    investment: number;
    planId: string;
    addonIds: string[];
    seats: number;
    result: number;
    preventRequest: boolean;
    recurrencePaymentMethod: RecurrencePaymentMethod;
}

export const getOrderSimulation = state => state.billing.order.simulation;
export const getRecurrencePayment = state => state.billing.order.simulation.recurrencePaymentMethod;

const initialState = {
    investment: 0,
    planId: null,
    addonIds: [],
    seats: 0,
    result: 0,
    preventRequest: false,
    recurrencePaymentMethod: RecurrencePaymentMethod.STRIPE,
    currency: DEFAULT_CURRENCY_USD,
};

export const getInitialOrderSimulation = () => ({
    type: GET_INITIAL_ORDER_SIMULATION,
    payload: {},
});

export const setInitialOrderSimulation = ({
    subscription,
}: {
    subscription: Partial<Subscription>,
}) => ({
    type: SET_INITIAL_ORDER_SIMULATION,
    payload: {
        subscription,
        preventRequest: true,
    },
});

export const editSimulation = simulation => ({
    type: EDIT_ORDER_SIMULATION,
    payload: {
        simulation,
    },
});

export const simulationReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [SET_INITIAL_ORDER_SIMULATION]: (state, action) => ({
        ...state,
        planId: action.payload.subscription.planId,
        addonIds: action.payload.subscription.addonIds,
        seats: action.payload.subscription.seats,
    }),
    [EDIT_ORDER_SIMULATION]: (state, action) => ({
        ...state,
        ...action.payload.simulation,
    }),
});
